<template>
    <div class="pagination">
        <paginate
            v-model="query.page"
            :click-handler="getPage"
            :container-class="'pagination-list list'"
            :next-text="'&rarr;'"
            :page-count="Math.ceil(resultsTotal / query.limit)"
            :page-range="isMobile ? 1 : 3"
            :prev-text="'&larr;'"
        />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import Paginate from 'vuejs-paginate';

    export default {
        name: 'Pagination',
        components: {
            Paginate,
        },
        computed: {
            ...mapState('filters', {
                originalQuery: 'query',
                resultsTotal: 'resultsTotal',
            }),
        },
        methods: {
            ...mapActions('filters', [
                'getPage',
            ]),

            cloneQuery() {
                this.query = JSON.parse(JSON.stringify(this.originalQuery));
            },
        },
        watch: {
            originalQuery: {
                handler: 'cloneQuery',
                immediate: true,
            },
        },
    };
</script>
